export const pt_BR = {
  // Certificate Headers
  congrats_message: "Sua instalação Wi-Fi está concluída e foi certificada pelo RouteThis!",
  installation_details: "Detalhes da Instalação",
  wireless_speed_test: "Teste de Velocidade Sem Fio",
  wireless_performance: "Wireless Performance",
  photos: "Fotos",
  signal_maps: "Mapas de Sinal",

  // Certificate Room Names
  singular_room: "Sala",
  room_type_bathroom: "Banheiro",
  room_type_bedroom: "Quarto",
  room_type_dining_room: "Sala de Jantar",
  room_type_entry_or_hall: "Entrada/Saguão",
  room_type_garage: "Garagem",
  room_type_kitchen: "Cozinha",
  room_type_living_room: "Sala de Estar",
  room_type_office: "Escritório",
  room_type_other: "Outro",

  // Pod Name
  pod_1: "Módulo Mesh",
  pod_2: "Ponto de Acesso",
  pod_3: "Nó Mesh",
  pod_4: "Puck Mesh",
  pod_5: "Beacon",
  pod_6: "Módulo Mesh",
  pods_1: "Módulos Mesh",
  pods_2: "Pontos de Acesso",
  pods_3: "Nós Mesh",
  pods_4: "Pucks Mesh",
  pods_5: "Beacons",
  pods_6: "Módulos Mesh",

  // Router Name
  router_1: "Roteador",
  router_2: "Modem",
  router_3: "Gateway",
  router_4: "Hub",
  router_5: "Roteador",

  // Level Name
  level_1: "Piso",
  level_2: "Andar",
  levels_1: "Pisos",
  levels_2: "Andares",

  // Certificate Pod Info
  recommended: "Recomendado",
  installed: "Instalado",
  total: "Total",

  // Certificate Signal Table
  front_building: "Frente do Edifício",
  speed: "Veloc.",
  video: "Vídeo",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Link",
  frequency_short: "Freq.",
  frequency_description: "MHz",
  channel_short: "Can.",

  // Certificate Legend
  legend: "Legenda",
  measured_speed: "Velocidade Medida",
  measured_speed_description: "Mbps",

  // Certificate Speedtest Result
  speedtest_passed: "A velocidade está dentro do intervalo esperado para a maioria dos dispositivos móveis. Nem todo dispositivo sem fio é capaz de alcançar a velocidade máxima do plano. Veja abaixo os testes para cômodos individuais.",
  speedtest_failed: "Testado em um celular ou tablet. Nem todo dispositivo sem fio é capaz de alcançar a velocidade máxima do plano. Veja abaixo os testes para cômodos individuais.",
}